import React from 'react';
import { Checkbox, Input, Label } from '../Form';
import Form from '../Form/Form';
import FormColumn from '../Form/FormColumn';
import { GrowyTextarea } from '@/components/Form/GrowyTextarea';
import WaterHazardsPicker from '@/components/WaterHazard/WaterHazardsPicker';

export type SurveyTemplateInput = {
  name?: string;
  description?: string;
  instructions: string;
  otherHazardsQuestion: boolean;
  allProtectedQuestion: boolean;
  hazardIds: string[];
};

type SurveyTemplateFormProps = {
  template: SurveyTemplateInput;
  onChange: (template: SurveyTemplateInput) => void;
  hazardsLoading?: boolean;
  readOnly?: boolean;
  hideNameDescription?: boolean;
};

const SurveyTemplateForm: React.FC<SurveyTemplateFormProps> = ({
  template,
  onChange,
  readOnly,
  hideNameDescription,
}) => {
  const handleFieldChange = (name: keyof SurveyTemplateInput, value: any) => {
    onChange({
      ...template,
      [name]: value,
    });
  };

  return (
    <Form>
      {!hideNameDescription && (
        <>
          <FormColumn>
            <Label htmlFor="template-name">Name</Label>
            <Input
              id="template-name"
              width="100%"
              type="text"
              value={template.name}
              onChange={(e) => handleFieldChange('name', e.target.value)}
              placeholder="Survey name"
              autoComplete="off"
              disabled={readOnly}
            />
          </FormColumn>
          <FormColumn>
            <Label htmlFor="template-description">Description</Label>
            <Input
              id="template-description"
              width="100%"
              type="text"
              value={template.description}
              onChange={(e) => handleFieldChange('description', e.target.value)}
              placeholder="Survey description"
              autoComplete="off"
              disabled={readOnly}
            />
          </FormColumn>
        </>
      )}
      <FormColumn>
        <Label htmlFor="template-instructions">Instructions</Label>
        <GrowyTextarea
          id="template-instructions"
          width="100%"
          value={template.instructions || ''}
          onChange={(e) => handleFieldChange('instructions', e.target.value)}
          placeholder="Instructions for the surveyor"
          autoComplete="off"
          disabled={readOnly}
          height={50}
          focusedHeight={66}
        />
      </FormColumn>
      <FormColumn>
        <Label>Hazards to check for</Label>
        <WaterHazardsPicker
          isClearable={false}
          isDisabled={readOnly}
          waterHazardIds={template.hazardIds}
          onChange={(waterHazards) => {
            handleFieldChange(
              'hazardIds',
              waterHazards ? waterHazards.map((o: any) => o.id) : []
            );
          }}
        />
      </FormColumn>
      <FormColumn>
        <Label display="flex" alignItems="center">
          <Checkbox
            checked={template.otherHazardsQuestion}
            onChange={(e) =>
              handleFieldChange('otherHazardsQuestion', e.target.checked)
            }
            disabled={readOnly}
          />
          Ask about other hazards
        </Label>
      </FormColumn>
      <FormColumn>
        <Label display="flex" alignItems="center">
          <Checkbox
            checked={template.allProtectedQuestion}
            onChange={(e) =>
              handleFieldChange('allProtectedQuestion', e.target.checked)
            }
            disabled={readOnly}
          />
          Ask if all hazards are protected
        </Label>
      </FormColumn>
    </Form>
  );
};

export default SurveyTemplateForm;
